import type { ReactNode } from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const containerVariants = cva("mx-auto w-full", {
  variants: {
    width: {
      reading: "max-w-[1920px] px-8",
      library: "library-container",
      training: "px-4 md:px-6",
    },
  },
  defaultVariants: { width: "reading" },
})

export function PageContainer({
  children,
  className,
  width,
}: { children: ReactNode; className?: string } & VariantProps<
  typeof containerVariants
>) {
  return (
    <div className={cn(containerVariants({ width }), className)}>
      {children}
    </div>
  )
}
